import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import Select from "components/common/Select";
import { Input } from "components/bootstrap";
import urlWithAuthParams from "enterprise-integrations/helpers/urlWithAuthParams";
import { ApiRoutes } from "./common/Routes";
import FormAdvancedOptions from "./FormAdvancedOptions";
import INITIAL_FORMDATA from "./_initialFormData";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const productName = useProductName();
  const { pollingInterval, o365DropSensitiveDlpLogs } = formData;
  const availableContent = [
    { label: "Azure ActiveDirectory", value: "AZURE_ACTIVE_DIRECTORY" },
    { label: "SharePoint", value: "SHAREPOINT" },
    { label: "Exchange", value: "EXCHANGE" },
    { label: t("o365.content_types.general"), value: "GENERAL" },
    { label: "DLP", value: "DLP_ALL" }
  ];
  const [contentTypes, setContentTypes] = useState(INITIAL_FORMDATA.availableContents.value);
  const [startSubscription, setStartSubscription] = useFetch(
    null,
    onSubmit,
    "POST",
    {
      o365_tenant_id: (_a = formData.tenantId) == null ? void 0 : _a.value,
      o365_client_id: (_b = formData.clientId) == null ? void 0 : _b.value,
      o365_client_secret: (_c = formData.clientSecret) == null ? void 0 : _c.value,
      o365_endpoint: ((_d = formData.subscriptionType) == null ? void 0 : _d.value) || "Enterprise and GCC government plans",
      o365_azuread_records: (_e = formData.contents) == null ? void 0 : _e.value.includes("AZURE_ACTIVE_DIRECTORY"),
      o365_exchange_records: (_f = formData.contents) == null ? void 0 : _f.value.includes("EXCHANGE"),
      o365_dlpall_records: (_g = formData.contents) == null ? void 0 : _g.value.includes("DLP_ALL"),
      o365_general_records: (_h = formData.contents) == null ? void 0 : _h.value.includes("GENERAL"),
      o365_sharepoint_records: (_i = formData.contents) == null ? void 0 : _i.value.includes("SHAREPOINT")
    },
    urlWithAuthParams
  );
  useEffect(() => {
    setStartSubscription(null);
    if (startSubscription.error) {
      setFormError({
        full_message: startSubscription.error,
        nice_message: t("o365.errors.unable_to_start_subscription")
      });
    }
    return () => {
      setFormError(null);
    };
  }, [setStartSubscription, startSubscription.error, t]);
  const handleSubmit = () => {
    let error = false;
    formData.contents.value = contentTypes;
    if (pollingInterval.value < 1) {
      setFormError({
        full_message: t("common.validation.polling_interval_invalid"),
        nice_message: t("common.validation.polling_interval_min")
      });
      error = true;
    }
    if (!error) {
      setFormError(null);
      setStartSubscription(ApiRoutes.INTEGRATIONS.O365.START_SUBSCRIPTION);
    }
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("o365.subscribe.start_subscription"),
      title: "",
      error: formError,
      loading: startSubscription.loading,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, t("o365.subscribe.log_types_label")),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        multi: true,
        name: "contents",
        id: "contents",
        onChange: (selected) => setContentTypes(selected),
        options: availableContent,
        value: contentTypes
      }
    ),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, t("o365.subscribe.content_types_help")),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue,
        min: "1",
        max: "60",
        onChange,
        required: true,
        help: t("o365.subscribe.polling_interval_help"),
        label: t("common.fields.polling_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "o365DropSensitiveDlpLogs",
        type: "checkbox",
        value: "enable-dropSensitiveDlpLogs",
        defaultChecked: o365DropSensitiveDlpLogs == null ? void 0 : o365DropSensitiveDlpLogs.value,
        onChange,
        label: t("o365.subscribe.drop_dlp_label"),
        help: t("o365.subscribe.drop_dlp_help", { productName })
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  );
};
export default StepSubscribe;
